export default {
    locais: [],
    local: {}
}